module.exports = __webpack_public_path__ + "static/media/sla-management.3576b661.svg";